// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__1AOoV","text":"loader_text__r-wqA","span":"loader_span__6qYxe","loaderSpan":"loader_loaderSpan__3izWf"};